import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { ControlActivationService } from 'src/app/_services/control-activation.service';
import { UserService } from 'src/app/_services/user.service';
import { ControlQrService } from 'src/app/_services/control-qr.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'src/app/_services/global.service';
import { ModalService } from 'src/app/shared/modal/modal.service';
import { ToasterMsgService } from 'src/app/shared/toaster-msg/toaster-msg.service';
declare var $: any;

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {
  userId;
  userName: string;
  userState;
  password: string;
  passwordMismatch: string = null;
  noOfShownRows: number;
  userType;
  userActivationBtn;
  modalType: string;
  parents: [];
  currLang;
  regenQrSingleUser;

  constructor(private userService: UserService,
    private dataService: DataService,
    private activationControl: ControlActivationService,
    private qrControl: ControlQrService,
    private translate: TranslateService,
    private globalService: GlobalService,
    private modalService: ModalService,
    private toasterService: ToasterMsgService
  ) { }

  ngOnInit(): void {
    $('#confirmModal').on('hidden.bs.modal', () => {
      this.cancelModalHandler();
    })

    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });

    this.dataService.getRowsNumberShown().subscribe(res => {
      this.noOfShownRows = res;
    })

    this.activationControl.getToggledUSer().subscribe((res: any) => {
      if (Object.keys(res).length > 0) {
        this.modalType = 'activation'
        this.userId = res.userId;
        this.userName = res.userName;
        this.userState = res.state;
        this.noOfShownRows = res.noOfShownRows;
        this.userType = res.type;
        this.userActivationBtn = res.event;
      }
    })

    this.qrControl.getParentsData().subscribe((res: any) => {
      if (Object.keys(res).length > 0) {
        this.modalType = 'regenerating';
        this.parents = res.noOfParents;
      }
    })

    this.qrControl.getRegenerateUserData().subscribe((res: any) => {
      this.modalType = 'singleRegenerating';
      this.regenQrSingleUser = res;
    })
  }

  getModalHeader(userState) {
    let status = userState ? this.translate.instant('confirm-modal.confirm-activating') : this.translate.instant('confirm-modal.confirm-deactivating');
    return status;
  }

  confirmFunction() {
    // verify password first
    if (this.checkPassword()) {
      this.checkPasswordAndTakeAction();
    }
    else {
      this.regenerateSingleQrCode();
    }
  }

  // not used
  regenerateQRCodes() {
    // regenerating codes
    let user_ids = [];
    this.parents.map((parent: any) => {
      user_ids.push(parent.id);
    })
    let body = { 'user_ids': user_ids };
    this.userService.regenerateCodes(body).subscribe((res: any) => {
      this.qrControl.setParentsData(res.success, 'multi');
      $("#qrModal").modal("show");
      this.closeModalHandler();
    })
  }

  regenerateSingleQrCode() {
    this.userService.regenerateQrCodePerUser(this.regenQrSingleUser.id).subscribe((res => {
      this.setToasterConfig('success', 'confirm-modal.regen-sucess');
      this.closeModalHandler();
    }), err => {
      this.setToasterConfig('failure', err?.error?.message);
      this.cancelModalHandler();
    })
  }
  changeUserActivaton() {
    // deactivating parents
    this.userService.changeUserActivation(this.userId, { 'is_active': this.userState ? 1 : 0 }).subscribe(res => {
      this.closeModalHandler();
    })
  }

  checkPassword() {
    return this.modalType != 'singleRegenerating' ? true : false;
  }

  checkPasswordAndTakeAction() {
    let password_body = { 'password': this.password }
    this.userService.verifyPassword(password_body).subscribe((res: any) => {
      if (this.modalType === 'activation') {
        this.changeUserActivaton();
      }
      else {
        // this.regenerateQRCodes();
      }
    }, (error) => {
      this.passwordMismatch = error.error.message
    })
  }

  setToasterConfig(type, msg) {
    let toasterConfigObj = type == 'success' ? {
      showToaster: true,
      showIcon: true,
      localizeMsg: true,
      iconType: 'checkMark',
      msg: msg
    } : {
      showToaster: true,
      showIcon: true,
      localizeMsg: false,
      iconType: 'crossMark',
      msg: msg
    }

    this.toasterService.setToasterConfig(toasterConfigObj); 
  }

  cancelModalHandler() {
    if (this.modalType === 'activation') {
      this.activationControl.setToggleUserBtn(this.userActivationBtn);
    }
    this.modalType = null;
    this.password = null;
    this.passwordMismatch = null;
    this.parents = [];
    $("#confirmModal").modal("hide");
  }

  closeModalHandler() {
    this.password = null;
    this.passwordMismatch = null;
    this.modalType = null;
    this.parents = [];
    this.dataService.setRowsNumberShown(this.noOfShownRows);
    $("#confirmModal").modal("hide");
    $("#addParentModal").modal("hide");
    $("#addStaffModal").modal("hide");
    this.modalService.closeModal();
  }
}
